import React from "react";


//  <CardCount title="Órdenes" value={124} icon={<FiFileText size={24} className='text-white' />} bg_icon={'bg-primary'} />
export const CardCount = ({
    title = "ÓRDENES",
    subtitle = "x",
    value = 0,
    icon,
    bg_icon = "#E7F1FF",
    iconColor = "#0D6EFD",
}) => {
    return (
        <div className="card border-0 shadow-sm rounded-3 ">
            <div className="card-body d-flex align-items-center gap-3 p-3">
                <div className={`d-flex align-items-center justify-content-center rounded-2 ${bg_icon}`} style={{ width: "45px", height: "45px" }} >
                    {icon}
                </div>
                <div>
                    <p className="text-uppercase fw-semibold mb-1" style={{ fontSize: "0.85rem", letterSpacing: "0.5px", color: "#6c757d" }}>
                        {title}
                    </p>
                    <h4 className="fw-bold mb-0">{value}</h4>
                </div>
            </div>
        </div>
    );
};
